import Constants from 'Constants'
import api from '../index'

const { SERVER_PORTAL_URL } = Constants

const extendedApi = api.injectEndpoints({
  endpoints: builder => ({
    getStatements: builder.query({
      query: ({ businessId, accountId }) => ({
        url: `${SERVER_PORTAL_URL}/api/v1/tenants/${businessId}/accounts/${accountId}/statements`,
        method: 'GET',
      }),
    }),
  }),
})

export const { useLazyGetStatementsQuery } = extendedApi
